import { ResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info';

import contentRequest from '~/src/api/requests/contentRequest';
import { IS_PRODUCTION_ENVIROMENT, REQUEST_TIMEOUT } from '~/src/constants';

// null не точно, там выше проверка
export async function getCities(): Promise<ResponseDto[] | null> {
    const params = {
        all: IS_PRODUCTION_ENVIROMENT ? '0' : '1',
    };
    const resp = await contentRequest.get('/v1/geography/get-all-cities', {
        params: params,
        timeout: REQUEST_TIMEOUT,
    });
    return resp.data;
}
